import { deleteData, getData, postData } from "./apiInstance";
import { AxiosResponse } from "axios";
import {
  AddDocumentLinkPayloadType,
  AddJobProgressCommentPayload,
  DeleteDocumentLinkPayloadType,
  GetAllAssignedClientsOpenJobsPayloadType,
  GetAllDocumentsLinkPayloadType,
  GetAllOpenItemsPayload,
  GetJobProgressCommentsPayload,
  GetJobTrackerListingPayload,
  GetWithStatusOpenItemsPayload,
  GetAllOpenJobListPayload,
  GetAdvenceInvoiceCountPayloadType,
  GetDailyActiveUserCountPayloadType,
  GetUserSessionLoginCountPayloadType,
  GetMonthlyActiveUserCountPayloadType,
  GetUserReportCountPayloadType,
  GetUserWiseInvoiceCountPayloadType,
  GetAllEInvoiceEWayBillListType,
  GetAllClientLockDateListType,
  GetAllExternalEmailerListType,
  GetInvoiceCountMonthlyPayloadType,
  GetAllUserApprovedEntryListType,
  GetAllClientBulkUploadHistoryPayloadType,
} from "../commonTypes/listing";
import { GetFileFolderCountPayloadType } from "../commonTypes/listing";
import { getCSRFToken } from "../utils/commonFunctions";

/* JOB TRACKER LISTING APIs */
export async function getAllJobsTrackerListApi(
  data: GetJobTrackerListingPayload
): Promise<AxiosResponse> {
  const { token, client_code, current_job } = data;
  return await getData(`odata/client/jobs`, {
    params: {
      client_code,
      current_job,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllJobProgressCommentsApi(
  data: GetJobProgressCommentsPayload
): Promise<AxiosResponse> {
  const { token, job_id } = data;

  return await getData(`jobs/comment/list`, {
    params: {
      job_id,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function addJobProgressCommentApi(
  data: AddJobProgressCommentPayload
): Promise<AxiosResponse> {
  const { token, job_id, comment } = data;

  let finalData = {
    comment,
    job_id,
  };

  return await postData(`jobs/comment/create`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getAllOpenJobsListApi(
  data: GetAllOpenJobListPayload
): Promise<AxiosResponse> {
  const { token, search_term, limit, offset, job_status } = data;

  //API replace
  return await getData(`jobs/open-jobs/list`, {
    // return await getData(`finac-crm/job/list`, {
    params: {
      search_term: search_term ?? "",
      limit,
      offset,
      job_status,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function addDocumentLinkApi(
  data: AddDocumentLinkPayloadType
): Promise<AxiosResponse> {
  const { link, job_id, description, token } = data;

  let finalData = {
    link,
    job_id,
    description,
  };

  return await postData(`jobs/add/link`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getDocumentsLinkApi(
  data: GetAllDocumentsLinkPayloadType
): Promise<AxiosResponse> {
  const { job_id, token } = data;

  return await getData(`jobs/link`, {
    params: {
      job_id,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function deleteDocumentLinkApi(
  data: DeleteDocumentLinkPayloadType
): Promise<AxiosResponse> {
  const { job_link_id, token } = data;
  let finalData = { job_link_id };

  return await deleteData(`jobs/delete/link`, {
    data: finalData,
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getAllAssignedClientsOpenJobsApi(
  data: GetAllAssignedClientsOpenJobsPayloadType
): Promise<AxiosResponse> {
  const { token, search_term } = data;

  return await getData(`jobs/open-jobs/client/list`, {
    params: {
      search_term: search_term ?? "",
      limit: 1000,
      offset: 0,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllOpenItemsApi(
  data: GetAllOpenItemsPayload
): Promise<AxiosResponse> {
  const { offset, limit, token } = data;

  return await getData(`open-item/all`, {
    params: {
      offset: 0,
      limit: 1000,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getWithStatusOpenItemsApi(
  data: GetWithStatusOpenItemsPayload
): Promise<AxiosResponse> {
  const { limit, offset, status_code, token } = data;

  return await getData(`open-item/all`, {
    params: {
      status_code,
      limit: 1000,
      offset: 0,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getFileFolderCountApi(
  data: GetFileFolderCountPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date } = data;

  return await getData(`reports/file-folders-count`, {
    params: {
      start_date: start_date.slice(0, 10),
      end_date,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getInvoiceCountApi(
  data: GetAdvenceInvoiceCountPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date, client_code } = data;

  return await getData(`report-module/invoice-report-count`, {
    params: {
      start_date,
      end_date,
      limit: 100000,
      offset: 0,
      client_code,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getDailyActiveUserReportApi(
  data: GetDailyActiveUserCountPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date } = data;

  return await getData(`report-module/daily-active-users`, {
    params: {
      start_date,
      end_date,
      limit: 100000,
      offset: 0,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getUserSessionLoginCountReportApi(
  data: GetUserSessionLoginCountPayloadType
): Promise<AxiosResponse> {
  const { token, start_date, end_date } = data;

  return await getData(`report-module/user-session-login-count`, {
    params: {
      start_date,
      end_date,
      limit: 100000,
      offset: 0,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getMonthlyActiveUserReportApi(
  data: GetMonthlyActiveUserCountPayloadType
): Promise<AxiosResponse> {
  const { token, financial_year } = data;

  return await getData(`report-module/monthly-active-users`, {
    params: {
      financial_year,
      limit: 100000,
      offset: 0,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getUserReportApi(
  data: GetUserReportCountPayloadType
): Promise<AxiosResponse> {
  const { token, user_id, start_date, end_date } = data;

  return await getData(`report-module/user-report`, {
    params: {
      start_date,
      end_date,
      user_id,
      limit: 100000,
      offset: 0,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getUserWiseInvoiceCountApi(
  data: GetUserWiseInvoiceCountPayloadType
): Promise<AxiosResponse> {
  const { token, user_id, start_date, end_date } = data;

  return await getData(`/report-module/daily-invoice-count`, {
    params: {
      start_date,
      end_date,
      user_id,
      limit: 100000,
      offset: 0,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllEInvoiceEWayBillListApi(
  data: GetAllEInvoiceEWayBillListType
): Promise<AxiosResponse> {
  const { token, list_type ,client_code,type} = data;

  return await getData(`/invoice-generation/e-way-bill/e-invoice/list`, {
    params: {
      list_type,
      client_code,
      type
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllClientLockDateApi(
  data: GetAllClientLockDateListType
): Promise<AxiosResponse> {
  const { token, limit, offset ,search_term,sortBy,sortByValue} = data;

  return await getData(`invoice-generation/all-client/locked-dates`, {
    params: {
      limit,
      offset,
      ...(search_term && search_term.length > 0 && { search_term: search_term }),
      ...(sortBy && sortBy.length > 0 && { sort_by: sortBy }),
      ...(sortByValue &&
        sortByValue.length > 0 && { sort_order: sortByValue }),


    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}


export async function getAllExternalUserEmailerApi(
  data: GetAllExternalEmailerListType
): Promise<AxiosResponse> {
  const { token, limit, offset ,search_term,
    sortBy,
    sortByValue,
    userId
  } = data;

  return await getData(`finac/user/emailer-setup`, {
    params: {
      limit,
      offset,
      user_id:userId,
      ...(search_term && search_term.length > 0 && { search_term: search_term }),
      ...(sortBy && sortBy.length > 0 && { sort_by: sortBy }),
      ...(sortByValue &&
        sortByValue.length > 0 && { sort_order: sortByValue }),


    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getInvoiceCountMonthlyGraphApi(
  data: GetInvoiceCountMonthlyPayloadType
): Promise<AxiosResponse> {
  const { token,
    start_date,
    end_date,
    type,
    client_code,
  } = data;

  return await getData(`report-module/monthly/invoice-report-count`, {
    params: {
      start_date,
      end_date,
      type,
      client_code,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    }
  })
}


export async function getAllUserApprovedEntryApi(
  data: GetAllUserApprovedEntryListType
): Promise<AxiosResponse> {
  const { token, limit, offset ,startDate,endDate,
  
    userId
  } = data;

  return await getData(`invoice-generation/approved/invoice/count/report`, {
    params: {
      limit,
      offset,
      user_id:userId,
      start_date:startDate,
      end_date:endDate



    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}


export async function getAllClientBulkUploadReportApi(
  data: GetAllClientBulkUploadHistoryPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset ,clientCode,type,status,
    userId
  } = data;

  return await getData(`invoice-generation/bulk/upload/report`, {
    params: {
      limit,
      offset,
      user_id:userId,
      client_code:clientCode,
      type,
      status

    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
